import React, { Component } from "react";
// import "./components/style.css";
import * as LINKS from "./constants/Links";
import { BrowserRouter as Router, Switch, Route, Redirect, Link } from "react-router-dom";
import AuthenticatedRoute from "./pages/AuthenticatedRoute/AuthenticatedRoute ";
import routers from "./routers";
import 'antd/dist/antd.min.css'
// import { connect } from "react-redux";
// import * as Actions from "./actions/index";
import authentication from "./components/authendication/Authentication";
//const baseUrl = document.getElementsByTagName('base')[0].getAttribute("href");
import { connect } from "react-redux";
import * as Actions from "./actions/index";
// import Header from "./components/Header/Header";
import Sidebar from "./components/Sidebar/index";
// import Home from "./pages/home/Home";
class App extends Component
{
  constructor(props)
  {
    super(props);
    this.state = {
      login: "",
      isToggle: true

    };

  }

  // static getDerivedStateFromProps(nextProps, prevState)
  // {

  //   if (nextProps.login.isLogined !== prevState.isLogined) {

  //     return { isLogined: nextProps.login.isLogined };

  //   }
  //   else {
  //     return null;
  //   }
  // }
  componentDidUpdate(prevProps, prevState)
  {

    if (this.state.isToggle !== prevState.isToggle) {
      let isspan = document.getElementsByClassName("ant-menu-title-content");
      let isrows = document.getElementsByClassName("ant-menu-submenu-arrow");
      let tgmenu = document.getElementsByClassName("tgmenu");
      let menu = document.getElementsByClassName("ant-layout-sider");
      let subs = document.getElementsByClassName("ant-menu-sub");

      if (!this.state.isToggle) {
        for (let i = 0; i < subs.length; i++) {
          const element = subs[i];
          element.style.height = "0px"
        }
        document.getElementsByClassName("ant-layout-content")[0].classList.add("hidden")
      }
      else {
        document.getElementsByClassName("ant-layout-content")[0].classList.remove("hidden")
      }
      if (!this.state.isToggle) {
        for (let i = 0; i < menu.length; i++) {
          const element = menu[i];
          element.classList.add("hidden");
          element.classList.remove("show")

        }
      } else {
        for (let i = 0; i < menu.length; i++) {
          const element = menu[i];
          element.classList.add("show")
          element.classList.remove("hidden")

        }
      }
      if (!this.state.isToggle) {
        for (let i = 0; i < tgmenu.length; i++) {
          const element = tgmenu[i];
          element.classList.add("hidden");
          element.classList.remove("show")

        }
      } else {
        for (let i = 0; i < tgmenu.length; i++) {
          const element = tgmenu[i];
          element.classList.add("show")
          element.classList.remove("hidden")

        }
      }
      if (!this.state.isToggle) {
        for (let i = 0; i < isspan.length; i++) {
          const element = isspan[i];
          element.classList.add("hidden");
          element.classList.remove("show")

        }
      } else {
        for (let i = 0; i < isspan.length; i++) {
          const element = isspan[i];
          element.classList.add("show")
          element.classList.remove("hidden")

        }
      }
      if (!this.state.isToggle) {
        for (let i = 0; i < isrows.length; i++) {
          const element = isrows[i];
          element.classList.add("hidden")
          element.classList.remove("show")
        }
      } else {
        for (let i = 0; i < isrows.length; i++) {
          const element = isrows[i];
          element.classList.add("show")
          element.classList.remove("hidden")

        }
      }
    }
  }
  RedirectLogin = () =>
  {
    <Redirect to="/login" />
  }
  render()
  {
    // console.log(authentication.isAuthenticated())
    let isLogined = authentication.isAuthenticated();
    isLogined = true

    return (
      <>
        <Router>
          <section className="ant-layout ant-layout-has-sider">

            <header className="ant-layout-header" style={{ background: "var(--main-background-color)", color: "var(--main-text-color)", height: "70px", position: "fixed", zIndex: "100", width: "100%", padding: "0px 16px", top: "-1px" }}>
              <nav className="flex items-center noselect">
                <div className="pr-2 pt-2 is-size-4" style={{ cursor: "pointer" }} onClick={() =>
                {
                  this.setState(state =>
                  {
                    return {
                      isToggle: !state.isToggle
                    }
                  })
                }}>
                  {this.state.isToggle && <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M904 160H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0 624H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0-312H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8z"></path></svg>
                  }
                  {!this.state.isToggle &&
                    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM115.4 518.9L271.7 642c5.8 4.6 14.4.5 14.4-6.9V388.9c0-7.4-8.5-11.5-14.4-6.9L115.4 505.1a8.74 8.74 0 0 0 0 13.8z">
                      </path>
                    </svg>
                  }
                </div>
                <a className="logo mr-3" href="/?chain=BSC">
                  <div className="logo-icon"><img src="/static/media/pinkswap.a95de4f3.png" alt="pinksale" /></div>
                  <div className="logo-text pt-1 hide-on-mobile">PinkSale</div>
                </a>
                <div className="flex-1"></div>
                <a href="https://www.dexview.com/" rel="nofollow noreferrer" target="_blank">
                  <div className="network"><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" height="18" width="18" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM305.8 637.7c3.1 3.1 8.1 3.1 11.3 0l138.3-137.6L583 628.5c3.1 3.1 8.2 3.1 11.3 0l275.4-275.3c3.1-3.1 3.1-8.2 0-11.3l-39.6-39.6a8.03 8.03 0 0 0-11.3 0l-230 229.9L461.4 404a8.03 8.03 0 0 0-11.3 0L266.3 586.7a8.03 8.03 0 0 0 0 11.3l39.5 39.7z">
                    </path>
                  </svg><span className="ml-2 hide-on-mobile">dexview.com</span></div>
                </a>
                <div className="network"><img src="/static/media/ic-bsc.419dfaf2.png" width="24" alt="chain-name" /><span className="ml-2 hide-on-mobile">BSC MAINNET</span></div>
                <a className="Account_root__3_VoB" href="/me?chain=BSC">
                  <div className="hide-on-mobile">
                    <div className="Account_address__3k1-V">0x2738...d223</div>
                    <div className="Account_balance__1zr_K">0.012067 BNB</div>
                  </div>
                  <div className="Account_avatar__3pqlg"><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                    <rect width="416" height="288" x="48" y="144" fill="none" stroke-linejoin="round"
                      stroke-width="32" rx="48" ry="48"></rect>
                    <path fill="none" stroke-linejoin="round" stroke-width="32"
                      d="M411.36 144v-30A50 50 0 00352 64.9L88.64 109.85A50 50 0 0048 159v49"></path>
                    <path d="M368 320a32 32 0 1132-32 32 32 0 01-32 32z"></path>
                  </svg></div>
                </a>
              </nav>
            </header>
            <Sidebar isToggle={this.state.isToggle} />
            <div className={!this.state.isToggle ? "overlay_menu" : "overlay_menu show"} onClick={() =>
            {
              this.setState(state =>
              {
                return {
                  isToggle: !state.isToggle
                }
              })
            }} ></div>
            {/* <Home /> */}
            <section className="ant-layout" >

              <main className="ant-layout-content MainLayout_content__2mZF9">
                <div className="Trending_trending__2ax2p">
                  <div className="Trending_title__3t1fM"><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                    <path fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"
                      d="M352 144h112v112"></path>
                    <path fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"
                      d="M48 368l121.37-121.37a32 32 0 0145.26 0l50.74 50.74a32 32 0 0045.26 0L448 160">
                    </path>
                  </svg>&nbsp;<span>Trending</span></div>
                  <ul className="Trending_items__2B7P8">
                    <li className="Trending_trendingItem__235g3"><span>#1</span>&nbsp;<Link to={LINKS.LAUNCHPAD_GC}>GC</Link></li>
                    <li className="Trending_trendingItem__235g3"><span>#2</span>&nbsp;<Link to={LINKS.LAUNCHPAD_GC}>$BINU</Link>
                    </li>
                    <li className="Trending_trendingItem__235g3"><span>#3</span>&nbsp;<Link to={LINKS.LAUNCHPAD_GC}>PC</Link></li>
                    <li className="Trending_trendingItem__235g3"><span>#4</span>&nbsp;<Link to={LINKS.LAUNCHPAD_GC}>$MYLA</Link>
                    </li>
                    <li className="Trending_trendingItem__235g3"><span>#5</span>&nbsp;<Link to={LINKS.LAUNCHPAD_GC}>AVA</Link></li>
                    <li className="Trending_trendingItem__235g3"><span>#6</span>&nbsp;<Link to={LINKS.LAUNCHPAD_GC}>PinkBET</Link>
                    </li>
                    <li className="Trending_trendingItem__235g3"><span>#7</span>&nbsp;<Link to={LINKS.LAUNCHPAD_GC}>BUSDv2</Link>
                    </li>
                    <li className="Trending_trendingItem__235g3"><span>#8</span>&nbsp;<Link to={LINKS.LAUNCHPAD_GC}>BPT</Link></li>
                    <li className="Trending_trendingItem__235g3"><span>#9</span>&nbsp;<Link to={LINKS.LAUNCHPAD_GC}>CUP</Link></li>
                    <li className="Trending_trendingItem__235g3"><span>#10</span>&nbsp;<Link to={LINKS.LAUNCHPAD_GC}>MMTKN</Link>
                    </li>
                    <li className="Trending_trendingItem__235g3"><span>#11</span>&nbsp;<Link to={LINKS.LAUNCHPAD_GC}>ARC</Link></li>
                    <li className="Trending_trendingItem__235g3"><span>#12</span>&nbsp;<Link to={LINKS.LAUNCHPAD_GC}>WCB</Link></li>
                  </ul>
                </div>
                <Switch>

                  {routers.length > 0 &&
                    routers.map((route, index) => (
                      <AuthenticatedRoute
                        key={index}
                        path={route.path}
                        exact={route.exact}
                        name={route.name}
                        isLogined={isLogined}

                        render={props => (
                          route.main({ ...props, routers: route.routers })
                        )}

                      />
                    ))}
                  <Route exact path={LINKS.endpoint + "/"}>
                    <Redirect to={LINKS.HOME} />
                  </Route>

                </Switch>
                <footer className="ant-layout-footer">
                  <div className="container">
                    <div className="copyright">
                      <p className="has-text-centered">Disclaimer: The information provided shall not in any way constitute a recommendation as to whether you should invest in any product discussed. We accept no liability for any loss occasioned to any person acting or refraining
                        from action as a result of any material provided or published.</p>
                    </div>
                    <div className="is-size-7 has-text-grey-light has-text-right">build: d8ddd7a</div>
                  </div>
                </footer>
              </main>


            </section>
          </section>
          <div>
            <div className="grecaptcha-badge" data-style="bottomright" style={{ width: "256px", height: "60px", display: "block", transition: "right 0.3s ease 0s", position: "fixed", bottom: "14px", right: "-186px", boxShadow: "gray 0px 0px 5px", borderRadius: "2px", overflow: "hidden" }}>
              <div className="grecaptcha-logo"><iframe title="reCAPTCHA" src="https://www.google.com/recaptcha/api2/anchor?ar=1&amp;k=6LeyAOUgAAAAABJdwvNeecnhcn6jZmauCKSlru-P&amp;co=aHR0cHM6Ly93d3cucGlua3NhbGUuZmluYW5jZTo0NDM.&amp;hl=vi&amp;v=Km9gKuG06He-isPsP6saG8cn&amp;size=invisible&amp;cb=hurge3plvj1o"
                width="256" height="60" role="presentation" name="a-8w8mrejyaryx" frameborder="0" scrolling="no" sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-top-navigation allow-modals allow-popups-to-escape-sandbox"></iframe>
              </div>
              <div className="grecaptcha-error"></div><textarea id="g-recaptcha-response-100000" name="g-recaptcha-response" className="g-recaptcha-response" style={{ width: "250px", height: "40px", border: "1px solid rgb(193, 193, 193)", margin: "10px 25px", padding: "0px", resize: "none", display: "none" }}></textarea>
            </div><iframe style={{ display: "none" }}></iframe>
          </div>
        </Router>
      </>
    );
  }
}

const mapStateToProps = (state) =>
{
  return {
    login: state.Login
  };
};

const mapDispatchToProps = (dispatch, props) =>
{
  return {
    // Login: (data) =>
    // {
    //   dispatch(Actions.LoginRequest(data));
    // },
    // ResetLogin: () =>
    // {
    //   dispatch(Actions.ResetLogin());
    // },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(App);

